<script>
import { Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Line as ChartLine } from 'vue-chartjs'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

export default {
  name: 'NetworkChart',
  components: { ChartLine },
  props: {
    client_id: Number,
    organisation_id: Number
  },
  async mounted() {
    await this.getOpenNetworkOutages(this.client_id, this.organisation_id);
  },
  data() {
    return {
      open_network_outages_loading: true,
      open_network_outages_data: {},
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Open netwerkstoringen',
            backgroundColor: '#40a7e3',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true
      }
    }
  },
  watch: {
    client_id: {
      handler(newVal) {
        this.getOpenNetworkOutages(newVal, this.organisation_id);
      }
    },
    organisation_id: {
      handler(newVal) {
        this.getOpenNetworkOutages(this.client_id, newVal);
      }
    }
  },
  methods: {
    async getOpenNetworkOutages(client_id, organisation_id) {
      this.open_network_outages_loading = true;
      try {
        const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/dashboard/' + client_id + '/open-network-outages/' + organisation_id, {
          credentials: 'include'
        });

        this.open_network_outages_data = await response.json();
      } catch (error) {
        console.error(error);
      } finally {
        this.fillChartData();
        this.open_network_outages_loading = false;
      }
    },
    fillChartData() {
      this.chartData.labels = this.open_network_outages_data.labels;
      this.chartData.datasets[0].data = this.open_network_outages_data.data;
    }
  },
}
</script>

<template>
    <ChartLine v-if="!open_network_outages_loading"
      id="open-network-outages-chart"
      :options="chartOptions"
      :data="chartData"
    />
</template>

<style scoped lang="scss">

</style>
